export const LEAD_SOURCES = [
  "IndiaMART",
  "Website",
  "Meta Ads",
  "Social Media",
  "Old Clients",
  "Direct",
];

export const PRODUCTS = [
  "TECH POUCH PRO",
  "TECH POUCH BLACK",
  "TECH POUCH GREY",
  "TECH POUCH BLUE",
  "TRAVEL SLING MINI BLACK",
  "TRAVEL SLING ULTRA",
  "TRAVEL SLING PRO",
];

export const POTENTIALS = ["Hot", "High", "Medium", "Low"];

export const STATUSES = [
  "New Lead",
  "Contacted",
  "In Negotiation",
  "Deal Won",
  "Deal Lost",
];

export const STATUS_COLORS = {
  "New Lead": {
    bg: "bg-violet-50",
    text: "text-violet-700",
    ring: "ring-violet-200",
    dot: "bg-violet-500",
  },
  Contacted: {
    bg: "bg-blue-50",
    text: "text-blue-700",
    ring: "ring-blue-200",
    dot: "bg-blue-500",
  },
  "In Negotiation": {
    bg: "bg-amber-50",
    text: "text-amber-700",
    ring: "ring-amber-200",
    dot: "bg-amber-500",
  },
  "Deal Won": {
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    ring: "ring-emerald-200",
    dot: "bg-emerald-500",
  },
  "Deal Lost": {
    bg: "bg-rose-50",
    text: "text-rose-700",
    ring: "ring-rose-200",
    dot: "bg-rose-500",
  },
};

export const POTENTIAL_COLORS = {
  Hot: "bg-rose-50 text-rose-700 ring-rose-200",
  High: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  Medium: "bg-amber-50 text-amber-700 ring-amber-200",
  Low: "bg-slate-100 text-slate-700 ring-slate-200",
};

export const SOURCE_COLORS = {
  IndiaMART: "#2563eb",
  Website: "#0ea5e9",
  "Meta Ads": "#8b5cf6",
  "Social Media": "#f59e0b",
  "Old Clients": "#10b981",
  Direct: "#6366f1",
};

export const formatINR = (n) => {
  const num = Number(n) || 0;
  return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};
